import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import TokenInvalid from './TokenInvalid';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  
  const [isTokenValid, setIsTokenValid] = useState(null); // null = chargement, true = ok, false = mort
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // Vérification du token à l'ouverture
  useEffect(() => {
    const verifyToken = async () => {
      try {
        await api.get(`/auth/verify-reset-token/${token}`);
        setIsTokenValid(true);
        
        // CETTE LIGNE CACHE LE TOKEN :
        // Elle remplace l'URL actuelle par une URL propre sans recharger la page
        window.history.replaceState(null, '', '/reset-password');
        
      } catch (err) {
        setIsTokenValid(false);
      }
    };
    verifyToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setIsTokenValid(false);
    } finally {
      setLoading(false);
    }
  };

  // 1. Pendant la vérification
  if (isTokenValid === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-blue-600" size={40} />
      </div>
    );
  }

  // 2. Si le token est mort, on affiche la page d'erreur
  if (isTokenValid === false) {
    return <TokenInvalid />;
  }

  // 3. Si le token est bon, on affiche le formulaire
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-[2.5rem] shadow-xl p-8 text-center">
        {success ? (
            <div className="space-y-4">
               <CheckCircle2 size={60} className="mx-auto text-emerald-500" />
               <h2 className="text-2xl font-black">Mot de passe mis à jour !</h2>
            </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <h2 className="text-2xl font-black text-slate-900">Nouveau mot de passe</h2>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={20} />
              <input 
                type="password" 
                required 
                className="w-full pl-12 pr-4 py-4 bg-slate-50 rounded-2xl outline-none focus:ring-2 focus:ring-blue-500 font-bold"
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button disabled={loading} className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black shadow-lg">
              {loading ? <Loader2 className="animate-spin mx-auto" /> : "Enregistrer le mot de passe"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;